import Stack from '@mui/material/Stack'
import ShieldCheck from '../../assets/icons/ShieldCheck.svg?react'

export const ProtectedIcon = () => {
    return (
        <Stack
            sx={{
                padding: '6px',
                background: '#EBF5FD',
                borderRadius: ' 8px',
            }}>
            <ShieldCheck
                style={{
                    color: '#006CFD',
                    background: '#EBF5FD',
                    height: '20px',
                    width: '20px',
                }}
            />
        </Stack>
    )
}
